<template>
  <JoszakiCard type="primary-alt" class="OnlineCoverageBanner">
    <p class="flex flex-row items-center gap-2 text-sm md:text-base">
      <IconComponent icon="globe" class="text-primary-light shrink-0" />
      <span>{{ $t("personProfile.location.onlineCoverage.listing") }}</span>
    </p>
  </JoszakiCard>
</template>

<script>
import JoszakiCard from "~/components/_refactored/common/JoszakiCard.vue";

export default {
  name: "OnlineCoverageBanner",
  components: {
    JoszakiCard,
  },
};
</script>
